import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { retrieveCurrentPrice } from "../../../Services/HistoryPriceApiService";
import { retrieveStockSession, retrieveStockDividend } from "../../../Services/StockSessionApiService";
import { Dividend, Dialog } from "../../Dividend/dialog";
import { DateTimer } from "../../Timer/dateTimer";
import { useAuthHeader } from "../../../auth/AuthService";

export default function HistoryPriceStockData2({mtype, icode, lang, stock}) {
    
    var START = 1;
    var MARKET_CLOSING = 99;
    const [STATE, setSTATE] = useState(START);
    const {t, i18n} = useTranslation();
    const [dividend, setDividend] = useState({});
    const authHeader = useAuthHeader();
    
    const [bPrice, setBPrice] = useState();
    const [ipoPrice, setIpoPrice] = useState();
    const [oPrice, setOPrice] = useState();
    const [hPrice, setHPrice] = useState();
    const [lPrice, setLPrice] = useState();
    const [closePrice, setClosePrice] = useState();
    const [vol, setVol] = useState();
    const [val, setVal] = useState();
    const [cPrice, setCPrice] = useState();
    const [change, setChange] = useState();
    const [cPer, setCPer] = useState();
    const [cArrow, setCArrow] = useState({});
    
    async function updateCurrentPrice() {
        mtype && icode && await retrieveCurrentPrice(icode, mtype, authHeader())
        .then((response) => {
            let data = response.data.data;
            setBPrice(data?.bprice);
            setOPrice(data?.oprice);
            setCPrice(data?.cprice);
            let sq = false;
            (data?.ctquantity == 0 && data?.bprice != data?.cprice) && (sq = true);
            setChange(data?.cchange);
            let per_change = (100 * Math.abs(data?.cchange) / data?.bprice);
            setCPer(per_change);
            setHPrice(data?.chigh);
            setLPrice(data?.clow);
            setVol(data?.ctquantity);
            setVal(data?.ctamount);
            setCArrow({
                comparePrice: data?.cchange, 
                tradeP: data?.cprice, 
                issue: data, 
                sq: sq
            });
            
        })
        .catch((error) => {console.log(error)})
        check();

        mtype && icode && await retrieveStockDividend(mtype, icode, authHeader())
        .then((response) => setDividend(response.data.data))
        .catch((error) => console.log(error));
    }

    async function check() {
        await retrieveStockSession(authHeader())
        .then((response) => {
            if (response.data.data.session) {
                updateClosing();
                setSTATE(MARKET_CLOSING);
            }
        })
        .catch((error) => console.log(error));
    }

    function updateClosing() {
        setClosePrice(cPrice);
        if (vol == 0 && bPrice == cPrice) {
            setHPrice(cPrice);
            setLPrice(cPrice);
        }
    }

    useEffect(() => {
        updateCurrentPrice();

        var intervalPrice = setInterval(updateCurrentPrice,5000);

        if (STATE == MARKET_CLOSING && (new Date().setHours(11,40,0)) < (new Date().getTime())) {
            clearInterval(intervalPrice);
        }

        return () => {
            clearInterval(intervalPrice);
        }
    }, [icode, lang]);

    return (
        <div className="grid text-sm md:text-lg">
            <div className="col-12 flex justify-content-between">
                <span className="font-bold md:text-xl">{t('Current Price')} : {cPrice && cPrice.toLocaleString('en-US')} &nbsp;
                    <UpDownSign 
                        comparePrice = {cArrow.comparePrice}
                        tradeP = {cArrow.tradeP}
                        issue = {cArrow.issue}
                        sq = {cArrow.sq}
                    /> <span className={change != 0 && change != null ? (change > 0 ? 'text-green' : 'text-red') : ''}>{change ? Math.abs(change) : '0'} ({(cPer || cPer == 0) && cPer.toFixed(2)}%)</span>
                    {/* <Dividend issue={stock} dividend={dividend}/> */}
                </span>
                <span className="font-bold">{t('Date')} : <DateTimer type={1}/>  (<DateTimer type={3}/>)</span>
            </div>
                
            <div className="col-12 font-bold">
                <span className="font-bold mb-0">
                    {t('Base Price')}  : {bPrice ? bPrice.toLocaleString('en-US') : '-'}&nbsp;&nbsp;
                    {t('Open (Top)')} : <span className={oPrice && oPrice != bPrice ? (oPrice > bPrice ? 'text-green' : 'text-red') : ''}>{oPrice ? oPrice.toLocaleString('en-US') : '-'}</span>   &nbsp;&nbsp;
                    {t('High (Top)')} : <span className={hPrice && hPrice != bPrice ? (hPrice > bPrice ? 'text-green' : 'text-red') : ''}>{hPrice ? hPrice.toLocaleString('en-US') : '-'}</span>  &nbsp;&nbsp; 
                    {t('Low (Top)')} : <span className={lPrice && lPrice != bPrice ? (lPrice > bPrice ? 'text-green' : 'text-red') : ''}>{lPrice ? lPrice.toLocaleString('en-US') : '-'}</span>   &nbsp;&nbsp;
                    {t('Close (Top)')} : <span className={ closePrice && closePrice != bPrice ? (closePrice > bPrice ? 'text-green' : 'text-red') : ''}>{closePrice ? closePrice.toLocaleString('en-US') : '-'}</span>   &nbsp;&nbsp;
                    {t('Volume')} ({t('shr')}) : <span>{vol ? vol.toLocaleString('en-US') : 0}</span> &nbsp;&nbsp;
                    {t('Value')} ({t('KHR')}) : <span>{val ? val.toLocaleString('en-US') : 0}</span> &nbsp;&nbsp;
                </span>
            </div>
            {/* <Dialog/> */}
        </div>
    )
}

function UpDownSign({comparePrice, tradeP, issue, sq}) {
    let img = "";
    if (issue) {
        if (sq) {
            if(comparePrice > 0) {
                if (tradeP == issue.hlprice) {
                    img = <img className="change-arrow" src="/img/sq_upper_sign.png"/>
                } else {
                    img = <img className="change-arrow" src="/img/sq_up_sign.png"/>
                }
            } else if (comparePrice < 0) {
                if (tradeP == issue.llprice) {
                    img = <img className="change-arrow" src="/img/sq_lower_sign.png"/>
                } else {
                    img = <img className="change-arrow" src="/img/sq_low_sign.png"/>
                }
            } else {
                img = <img className="change-arrow" src="/img/unchange_sign.png"/>
            }
        } else {
            if(comparePrice > 0) {
                if (tradeP == issue.hlprice) {
                    img = <img className="change-arrow" src="/img/upper_sign.png"/>
                } else {
                    img = <img className="change-arrow" src="/img/up_sign.png"/>
                }
            } else if (comparePrice < 0) {
                if (tradeP == issue.llprice) {
                    img = <img className="change-arrow" src="/img/lower_sign.png"/>
                } else {
                    img = <img className="change-arrow" src="/img/low_sign.png"/>
                }
            } else {
                img = <img className="change-arrow" src="/img/unchange_sign.png"/>
            }
        }
        
    }
    
    return (
        <>
            {img}
        </>
    )
}